import Context from "../../../../../../context/Context"

function can(obj, methodName) {
  return (obj && (typeof obj[methodName]) === "function")
}

function createErrorMessage(name) {
  const i18n = Context.instance.i18n
  return i18n.more.bookWorkspace.interfaceError.replace("{function}", name)
}

export function login(obj) {
  const name = "login"
  if (can(obj, name)) {
    return obj.login()
  } else {
    console.error(createErrorMessage(name))
  }
}

export function getAccessToken(obj) {
  const name = "getAccessToken"
  if (can(obj, name)) {
    return obj.getAccessToken()
  } else {
    console.error(createErrorMessage(name))
  }
}

export function getBookingSchedule(obj, accessToken, params) {
  const name = "getBookingSchedule"
  if (can(obj, name)) {
    return obj.getBookingSchedule(accessToken, params)
  } else {
    console.error(createErrorMessage(name))
  }
}

export function logout(obj, reloadUrl) {
  const name = "logout"
  if (can(obj, name)) {
    return obj.logout(reloadUrl)
  } else {
    console.error(createErrorMessage(name))
  }
}

export function getLoggedInUser(obj) {
  const name = "getLoggedInUser"
  if (can(obj, name)) {
    return obj.getLoggedInUser()
  }
  else {
    console.error(createErrorMessage(name))
  }
}

export function bookWorkspace(obj, accessToken, params) {
  const name = "bookWorkspace"
  if (can(obj, name)) {
    return obj.bookWorkspace(accessToken, params)
  } else {
    console.error(createErrorMessage(name))
  }
}

export function checkAvailability(obj, uniqueIds, checkIn, checkOut) {
  const name = "checkAvailability"
  if (can(obj, name)) {
    return obj.checkAvailability(uniqueIds, checkIn, checkOut)
  } else {
    console.error(createErrorMessage(name))
  }
}

export function cancelBooking(obj, attributes){
  const name = "cancelBooking"
  if (can(obj, name)) {
    return obj.cancelBooking(attributes);
  } else {
    console.error(createErrorMessage(name))
  }
}

export function updateCheckInOut(obj, attributes, state) {
  const name = "updateCheckInOut";
  if (can(obj, name)) {
    return obj.updateCheckInOut(attributes, state);
  } else {
    console.error(createErrorMessage(name))
  }
}

export function queryCheckInOut(obj, uniqueId) {
  const name = "queryCheckInOut";
  if (can(obj, name)) {
    return obj.queryCheckInOut(uniqueId);
  } else {
    console.error(createErrorMessage(name))
  }
}
